import {
  IKpiObjectiveContractSavePayload,
  IKpiContractResponsibility,
  IKpiContractCompetence,
  IKpiContractIndicator,
  IKpiContractObjective,
  IKpiContractValidation,
} from './objectivecontract.models';

export const emptyObjectiveContract = (): IKpiObjectiveContractSavePayload => ({
  contract: {
    staffix: '',
    contractyear: new Date().getFullYear(),
    versionno: 1,
    positiontitle: '',
    positioncode: '',
    institution: 'SONABHY',
    department: '',
    service: '',
    category: '',
    alignmentix: '',
    mission: '',
    superiorrelation: '',
    inferiorrelation: '',
    internalrelations: '',
    externalrelations: '',
    generalequipment: '',
    specificequipment: '',
    educationlevel: '',
    domain: '',
    speciality: '',
    experience: '',
    stateix: '',
    status: 1,
  },
  responsibilities: [],
  competences: [],
  indicators: [],
  objectives: [],
  validations: [],
});

export const newResponsibility = (seqno: number): IKpiContractResponsibility => ({
  impactix: '',
  responsibility: '',
  seqno,
  status: 1,
});

export const newCompetence = (seqno: number): IKpiContractCompetence => ({
  competencetypeix: '',
  competencename: '',
  levelix: '',
  seqno,
  status: 1,
});

export const newIndicator = (seqno: number): IKpiContractIndicator => ({
  indicatorname: '',
  seqno,
  status: 1,
});

export const newObjective = (seqno: number, objectivetypeix = ''): IKpiContractObjective => ({
  objectivetypeix,
  templateix: '',
  objectivetitle: '',
  specific: '',
  measurable: '',
  achievable: '',
  relevant: '',
  timebound: '',
  weight: '',
  targetvalue: '',
  seqno,
  status: 1,
});

export const newValidation = (seqno: number): IKpiContractValidation => ({
  validatorix: '',
  validationrole: '',
  fullname: '',
  validated: false,
  validationdate: '',
  remarks: '',
  seqno,
  status: 1,
});
